import ConsoleLogger from 'amazon-chime-sdk-js/build/logger/ConsoleLogger';
import LogLevel from 'amazon-chime-sdk-js/build/logger/LogLevel';

const localLogger = new ConsoleLogger('patient-telehealth-app', LogLevel.INFO);

export default localLogger;
